"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsV2Service = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class TeamsV2Service {
    /**
     * @returns GetTeamsResponse Success
     * @throws ApiError
     */
    static getV2Teams() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/teams',
        });
    }
}
exports.TeamsV2Service = TeamsV2Service;
